import React from 'react';
import Card from './cards/card/card';
import Message from './misc/message/message';
import Button from './ui/button/button';
import Dropdown from './ui/dropdown/dropdown';
import Total from './misc/total/total';
import Checkbox from './ui/checkbox/checkbox';
import Input from './ui/inputs/inputs';
import CountrySelector from './ui/country/countrySelector';
import LanguageSelector from './ui/language/languageSelector';
import PhoneInput from './ui/phone/phoneInput';
import DatePicker, { BirthdatePicker } from './ui/date-picker/datePicker';
import Icon from './ui/icon/icon';
import TextArea from './ui/textArea/textArea';
import SeparationTitle from './ui/separationTitle/separationTitle';
import UploadInput from "./misc/upload/uploadInput";
import Counter from './ui/counter/counter';
import ToggleLabel from './ui/toggle/toggle';
import Modal from './ui/modal/modal';
import EventsFilter from './misc/eventsFilter/eventsFilter';
import AddressAutocomplete from './ui/addressAutocomplete/addressAutocomplete';
import StepHeader from "./misc/stepHeader/stepHeader";
import ItemCardActionButton from './cards/itemCard/components/itemCardActionButton/itemCardActionButton';
import ItemCard from './cards/itemCard/itemCard';
import ItemCardInfos from './cards/itemCard/components/itemCardInfos/itemCardInfos';
import OrderCard from './cards/orderCard/orderCard';

export default function Components() {
    const [value, setValue] = React.useState('');
    const [checked, setChecked] = React.useState('');
    const [checkedToggle, setCheckedToggle] = React.useState('');
    const [countrySelected, setCountrySelected] = React.useState('');
    const [counterValue, setCoutnerValue] = React.useState('');
    const [mandatoryDropdown, setMandatoryDropdown] = React.useState('');
    const [errorDropdown, setErrorDropdown] = React.useState('');
    const [dateOrder, setDateOrder] = React.useState('2023-05-02 15:00:00');
    const [errorOrder, setErrorOrder] = React.useState('');
    const [openModal, setOpenModal] = React.useState(false);
    const [addressValue, setAddressValue] = React.useState('');
    const [languageHeader, setLanguageHeader] = React.useState('fr-FR');


    const [dateError, setDateError] = React.useState('');
    const [dateRegistration, setDateRegistration] = React.useState('');
    const localeDates = 'SR';
    const [language, setLanguage] = React.useState('');
    const [file, setFile] = React.useState('ticket/O139745/Wpremier_widget_vente_2/C17060511-0e35-4ff1-84ef-41e09a9dd142/3557b1d4-fa46-b8f2-e799-708d50665126/ws-46/79bce739-7ad8-e2dc-02e8-d032a38199bc.jpeg');

    const uploadConfig = {
        "url": "https://pyvar-e-staging-weezevent.s3.amazonaws.com/",
        "fields": {
            "key": "ticket/O139745/Wpremier_widget_vente_2/Cba99b17c-c052-4fc2-8bde-f6ecdae1ac74/5ea3c580-7cad-7be5-5997-4cafcb2fa572/ws-46/${filename}",// eslint-disable-line
            "AWSAccessKeyId": "ASIATQDFFJPQXHBGOPCK",
            "x-amz-security-token": "IQoJb3JpZ2luX2VjENz//////////wEaCWV1LXdlc3QtMSJGMEQCIG5uNT/pT9wgw+wmsQeZyGAmQjW8lgITV1WgKJhm+7J8AiAjpj8XfssBSDLo+7MY6UUIiLDUp/7Xj0IJIzUWIGtkXyruAwjF//////////8BEAQaDDI0MDczMDMyODAzMyIM9KMXX91Ez22AFp2iKsIDMuW1RaZO9JcvIRNg2OI6+XaZEIRVLHZqsoJPUfU504uXmrV52QU4Bf7VZw0j+BoGsqtp2K0cMjzMzdAgq4Bv3qyPllY1D1a7RhTVDczzZ+VZIpYnO/tvW9CVWBESsIixXaeF9eG2lAjJeBviT47XMI02oE++1OFDZAJQgBO3Sg1PegtDArR6THbXIvoyTDDJm4mPK+YFDcJuycGFnW7RX9JTRdCvNkIvZsbYfr7RtW1emegTqpdSTU9XVHk62q5ugUERmnFji7YAXBOzaX/UEtMnr7Bf1qwWQTVYuOmT7XZzcvMOybm3vZVJjSQzm6bQQ56mQ/8WK0Nk3TTTF+A3EBgHR9vyiFjJBlB+pWCwMYyJeV81JP6DQk4Jju3TSUpDl/3F7UFoW+d5Ozqz90nJkRXLGTd5ZZpuHnkypmYPuW9XapxsqIdHGXf7S0wxwRTn+Gl5dvO3oTfI0Jg72wnLgZrBejyRfZ84qSZFliL0V1YVOjnqwsCT4CDdq5wNAxhhJkFBNMAAYge9QNMdrBi0CNwsSE9Pa+ci8H95Xy+BVik2owgDuoNXxelwSMQ8Jn8tpeaX60NicG4Yb+5xCetlgRNxMNjL864GOqYBIux8Cz9hawDwHPLI33dt3VAA9DpO/3ZHRLiAkIlV07ag42AluQnpH5LYk9V8dXEHRArTXnwmVHWpBd6FGPapW5JtV+4qgr7x1+PZSGs4LHbaFFpOnueTEHSXBClH8GYSMPfkhtRJwJYsQRSIMVwOW5ik2XnwZRJp1xUN9D8IdLS1eTyETuK+jCGLSJQLQP5CT1bQxJKAaOfBURvR22XhuCoIXJ65bw==",
            "policy": "eyJleHBpcmF0aW9uIjogIjIwMjQtMDItMjZUMjE6MTc6MjdaIiwgImNvbmRpdGlvbnMiOiBbWyJjb250ZW50LWxlbmd0aC1yYW5nZSIsIDEsIDIwOTcxNTJdLCB7ImJ1Y2tldCI6ICJweXZhci1lLXN0YWdpbmctd2VlemV2ZW50In0sIFsic3RhcnRzLXdpdGgiLCAiJGtleSIsICJ0aWNrZXQvTzEzOTc0NS9XcHJlbWllcl93aWRnZXRfdmVudGVfMi9DYmE5OWIxN2MtYzA1Mi00ZmMyLThiZGUtZjZlY2RhZTFhYzc0LzVlYTNjNTgwLTdjYWQtN2JlNS01OTk3LTRjYWZjYjJmYTU3Mi93cy00Ni8iXSwgeyJ4LWFtei1zZWN1cml0eS10b2tlbiI6ICJJUW9KYjNKcFoybHVYMlZqRU56Ly8vLy8vLy8vL3dFYUNXVjFMWGRsYzNRdE1TSkdNRVFDSUc1dU5UL3BUOXdndyt3bXNRZVp5R0FtUWpXOGxnSVRWMVdnS0pobSs3SjhBaUFqcGo4WGZzc0JTRExvKzdNWTZVVUlpTERVcC83WGowSUpJelVXSUd0a1h5cnVBd2pGLy8vLy8vLy8vLzhCRUFRYURESTBNRGN6TURNeU9EQXpNeUlNOUtNWFg5MUV6MjJBRnAyaUtzSURNdVcxUmFaTzlKY3ZJUk5nMk9JNitYYVpFSVJWTEhacXNvSlBVZlU1MDR1WG1yVjUyUVU0QmY3Vlp3MGorQm9Hc3F0cDJLMGNNanpNemRBZ3E0QnYzcXlQbGxZMUQxYTdSaFRWRGN6elorVlpJcFluTy90dlc5Q1ZXQkVTc0lpeFhhZUY5ZUcybEFqSmVCdmlUNDdYTUkwMm9FKysxT0ZEWkFKUWdCTzNTZzFQZWd0REFyUjZUSGJYSXZveVREREptNG1QSytZRkRjSnV5Y0dGblc3Ulg5SlRSZEN2TmtJdlpzYllmcjdSdFcxZW1lZ1RxcGRTVFU5WFZIazYycTV1Z1VFUm1uRmppN1lBWEJPemFYL1VFdE1ucjdCZjFxd1dRVFZZdU9tVDdYWnpjdk1PeWJtM3ZaVkpqU1F6bTZiUVE1Nm1RLzhXSzBOazNUVFRGK0EzRUJnSFI5dnlpRmpKQmxCK3BXQ3dNWXlKZVY4MUpQNkRRazRKanUzVFNVcERsLzNGN1VGb1crZDVPenF6OTBuSmtSWExHVGQ1WlpwdUhua3lwbVlQdVc5WGFweHNxSWRIR1hmN1Mwd3h3UlRuK0dsNWR2TzNvVGZJMEpnNzJ3bkxnWnJCZWp5UmZaODRxU1pGbGlMMFYxWVZPam5xd3NDVDRDRGRxNXdOQXhoaEprRkJOTUFBWWdlOVFOTWRyQmkwQ053c1NFOVBhK2NpOEg5NVh5K0JWaWsyb3dnRHVvTlh4ZWx3U01ROEpuOHRwZWFYNjBOaWNHNFliKzV4Q2V0bGdSTnhNTmpMODY0R09xWUJJdXg4Q3o5aGF3RHdIUExJMzNkdDNWQUE5RHBPLzNaSFJMaUFrSWxWMDdhZzQyQWx1UW5wSDVMWWs5VjhkWEVIUkFyVFhud21WSFdwQmQ2RkdQYXBXNUp0Vis0cWdyN3gxK1BaU0dzNExIYmFGRnBPbnVlVEVIU1hCQ2xIOEdZU01QZmtodFJKd0pZc1FSU0lNVndPVzVpazJYbndaUkpwMXhVTjlEOElkTFMxZVR5RVR1SytqQ0dMU0pRTFFQNUNUMWJReEpLQWFPZkJVUnZSMjJYaHVDb0lYSjY1Ync9PSJ9XX0=",
            "signature": "LmPnTTkYPXnHRT4mVdW7H8SDVV4="
        }
    };

    const data = {
        "waiting_list_tickets": {
            "messages":[],
            "waiting_tickets_list": [{
                "rate_name": 'Rate name',
                "event_name": 'Event name',
                "status": 'expired',
                "informations_title": "Waiting list informations",
                "informations": [
                    {
                        label: "Subscription date",
                        key: 'created',
                        value: '2021-12-08T10:00:00'
                    },
                    {
                        label: "Quantity requested",
                        key: 'quantity',
                        value: 3
                    }
                ],
                "actions": {
                    'mainAction': {
                        label: "main action",
                        icon: "arrowRight",
                        onClick: () => {}
                    },
                    'infosAction': {
                        label: "infos action",
                        icon: "infoCircle",
                        onClick: () => {}
                    }
                },
            }]
        }
    }
    const orderCardData = {
        "orders_list": {
            "messages": [],
            "orders": [{
                "currency": "EUR",
                "transaction_reference": "C231E391331O40",
                "status": 'reservation',
                "informations_title": "Détails de la commande",
                "informations": [
                    {
                        label: "Buyer name",
                        key: 'buyer_name',
                        value: 'Brad Pitt',
                        type: 'string'
                    },
                    {
                        label: "Order sold date",
                        key: 'order_sold_date',
                        value: "2023-05-05T14:00:00Z",
                        type: 'date',
                        timezone: 'Europe/Paris'
                    },
                    {
                        label: "Order price",
                        key: 'paid_price',
                        value: '10.00',
                        type: 'amount',
                        currency: "EUR"
                    }
                ],
                "attendees_count": 20,
                "event": {
                    "address": {
                        "address1": '10 rue de la Vilette',
                        "zip_code": "75000",
                        "city": "Paris",
                        "country": "France"
                    },
                    "name": 'Event name',
                    "picture": 'full_picture',
                    "timezone": 'Europe/Paris',
                    "full_picture": null,
                    // "full_picture": "https://wzeweb-p-visuelorga-evn-affiche.s3.eu-west-1.amazonaws.com/affiche_982521.png",
                    "start_date": "2023-05-05T14:00:00Z",
                    "end_date": "2029-05-06T14:00:00Z"
                },
                "actions": [{action: "OrderMenuStep"}]
            }]
        },
    }

    return (
        <div style={{padding: '15px'}}>
            <ItemCard 
                status={data.waiting_list_tickets.waiting_tickets_list[0].status} 
                title={data.waiting_list_tickets.waiting_tickets_list[0].rate_name}
                subtitle={data.waiting_list_tickets.waiting_tickets_list[0].event_name}
                actions={data.waiting_list_tickets.waiting_tickets_list[0].actions}
            >
                <ItemCardInfos 
                    title={data.waiting_list_tickets.waiting_tickets_list[0].informations_title}
                    informations={data.waiting_list_tickets.waiting_tickets_list[0].informations}
                />
            </ItemCard>
            <br/>
            <br/>
            <br/>
            <div style={{backgroundColor: '#F1F3F9', padding: '20px 5px'}}>
                <OrderCard
                    order={orderCardData.orders_list.orders[0]}
                    event={orderCardData.orders_list.orders[0].event}
                >
                    <ItemCardInfos 
                        alternativeStyle
                        title={orderCardData.orders_list.orders[0].informations_title}
                        informations={orderCardData.orders_list.orders[0].informations}
                    />
                </OrderCard>
            </div>
            <br/>
            <div style={{display: 'flex', flexWrap: 'wrap', columnGap: '5px'}}>
                <ItemCardActionButton label='Primary' icon='infoCircle' onlyIcon/>
                <ItemCardActionButton label='Inverted' type='inverted' icon='infoCircle' onlyIcon/>
                <ItemCardActionButton label='Validate' icon='checkSimple' type='confirm' onlyIcon/>
                <ItemCardActionButton label='Delete' type='delete' icon='cross' onlyIcon/>
                <ItemCardActionButton label='is loading' type='delete' icon='cross' onlyIcon isLoading={true}/>
            </div>
            <br/>
            <div style={{display: 'flex', flexWrap: 'wrap', columnGap: '5px'}}>
                <ItemCardActionButton label='Primary'/>
                <ItemCardActionButton label='Inverted' type='inverted'/>
                <ItemCardActionButton label='Validate' type='confirm'/>
                <ItemCardActionButton label='Delete' type='delete'/>
                <ItemCardActionButton label='is loading' type='delete' isLoading={true}/>
            </div>
            <br/>
            <ToggleLabel label='Simple Concombre' checked={ checkedToggle } onChange={(e, value) => setCheckedToggle(value)}/> 
            <br/>
            <ToggleLabel label='Simple Concombre disabled' disabled/> 
            <br/>
            <ToggleLabel label='Simple Concombre sublabel' sublabel='Green Concombre'/> 
            <br/>
            <ToggleLabel label='Simple Concombre required' required/> 
            <br/>
            <ToggleLabel label='Concombre right sub' inlinePosition='right' required sublabel='Green Concombre'/> 
            <br/>
            <ToggleLabel label='Concombre right' inlinePosition='right' required/> 
            <br/>
            <ToggleLabel label='Concombre left sub' inlinePosition='left' required sublabel='Green Concombre'/> 
            <br/>
            <ToggleLabel label='Concombre right' inlinePosition='right'/> 
            <br/>
            <ToggleLabel label='Concombre left' inlinePosition='left'/> 
            <br/>
            <ToggleLabel label='Concombre error' error='Error message'/> 
            <br/>
            <Button label='open modal' onClick={() => setOpenModal(true)}/>
            <Modal 
                title='Le concombre est l’exemple même du légume rafraîchissant' 
                subtitle='il augmente la sensation de satiété, ce qui évite les fringales nocturnes. il favorise le bon transit intestinal.' 
                open={openModal}
                onClose={() => setOpenModal(false)}
                submitButton={
                    <Button label='submit' onClick={() => console.log('submit')}/>
                }
                customButton={
                    <Button type='inverted' label='custom' onClick={() => console.log('custom')}/>
                }
                cancelButton={
                    <Button type='inverted-secondary' label='cancel' onClick={() => setOpenModal(false)}/>
                }
            >
                <>
                    <TextArea disableResize label='TextArea disableResize' placeholder='placeholder textarea'/>
                    <SeparationTitle label='Le concombre est l’exemple même du légume rafraîchissant' description='il augmente la sensation de satiété, ce qui évite les fringales nocturnes. il favorise le bon transit intestinal.'/>
                    <Input label='LABEL' placeholder='placeholder'/>
                    <TextArea disableResize label='TextArea disableResize' placeholder='placeholder textarea'/>
                    <SeparationTitle label='Le concombre est l’exemple même du légume rafraîchissant' description='il augmente la sensation de satiété, ce qui évite les fringales nocturnes. il favorise le bon transit intestinal.'/>
                    <Input label='LABEL' placeholder='placeholder'/>
                </>
            </Modal>
            <br/>
            <br/>
            <SeparationTitle label='Le concombre est l’exemple même du légume rafraîchissant' description='il augmente la sensation de satiété, ce qui évite les fringales nocturnes. il favorise le bon transit intestinal.'/>
            <Counter value={counterValue} onChange={(e, value) => setCoutnerValue(value)}/>
            <br/>
            <SeparationTitle label='Le concombre est l’exemple même du légume rafraîchissant'/>
            <TextArea label='TextArea' placeholder='placeholder textarea' value={value} onChange={({ target: { value } }) => setValue(value)}/>
            <TextArea disableResize label='TextArea disableResize' placeholder='placeholder textarea'/>
            <TextArea errors='Error message' label='Error TextArea'/>
            <TextArea disabled placeholder='disabled textArea' label='Disabled TextArea'/>
            <TextArea description='description blabla' placeholder='Textarea with description' label='With description'/>

            <br/>
            <Input label='LABEL' placeholder='placeholder'/>
            <Input required label='Required'/>
            <Input error='Error message' label='Error'/>
            <Input disabled placeholder='disabled' label='Disabled'/>
            <Input description='description blabla' placeholder='with description' label='Disabled'/>
            <Input placeholder='with icon' icon='ticket' label='With icon'/>
            <Input placeholder='with counter' showLength maxLength='50' label='Counter'/>
            <Checkbox label="checkbox" onChange={() => console.log('change')}/>
            <br/>
            <Checkbox label="disabled" disabled onChange={() => console.log('change')}/>
            <br/>
            <Checkbox required label="required" onChange={() => console.log('change')}/>
            <br/>
            <Checkbox label="error" errors='Error message' checked={checked} onChange={() => setChecked(checked => !checked)}/>
            <br/>
            <Checkbox label="title" description='description' onChange={() => console.log('change')}/>
            <br/>
            <br/>
            <Total totalData={{title:'Total'}} quantity={23}/>
            <br/>
            <Message type='info' title={"Info message"} description={"info"} ctaLabel='GO TO HELL'/>
            <br/>
            <Message type='success' ctaLabel='CTA Label' title={"Success message"} description={"success"}/>
            <br/>
            <Message type='warning' ctaLabel='CTA Label' title={"Tubariphobie"} description={"La peur des cornichons."}/>
            <br/>
            <Message type='danger' ctaLabel='CTA Label' title={"Cucurbitophobie"} description={"En pathologie, crainte exagérée des cucurbitacées (melons, cornichons, concombres). En pathologie, crainte exagérée des cucurbitacées (melons, cornichons, concombres). En pathologie, crainte exagérée des cucurbitacées (melons, cornichons, concombres). En pathologie, crainte exagérée des cucurbitacées (melons, cornichons, concombres)"}/>
            <br/>
            <Card title={"Le concombre (Cucumis sativus) est une espèce de plante à fleurs de la famille des Cucurbitacées."} description={"so sad without icon"}/>
            <br/>
            <Card title={"With icon"} description={"Concombre ? "} icon={<Icon name='sendMail' size='large'/>}/>
            <br/>
            <Card cta ctaLabel='CTA Label' title={"With CTA"} description={"icon bg, button bof"} icon={<Icon name='sendMail' size='large'/>}/>
            <br/>
            <Card externalLink='https://www.google.com' externalLinkText='external link' title={"With External link"} description={"icon bg, external link ah"} icon={<Icon name='sendMail' size='large'/>}/>
            <br/>
            <Card checkbox title={"With Checkbox"} description={"icon bg, checkbox"}/>
            <br/>
            <Card input cancelLabel='Cancel' submitLabel='Submit' title={"With Input"} description={"input roh"}/>
            <br/>
            <Button type='primary' label='primary button'/>
            <br/>
            <Button type='secondary' label='secondary button'/>
            <br/>
            <Button type='inverted' label='inverted button'/>
            <br/>
            <Button type='inverted-secondary' label='inverted secondary button'/>
            <br/>
            <Button disabled type='primary' label='primary button'/>
            <br/>
            <Button disabled type='secondary' label='secondary button'/>
            <br/>
            <Button disabled type='inverted' label='inverted button'/>
            <br/>
            <Button disabled type='inverted-secondary' label='inverted secondary button'/>
            <br/>
            <Button disabled type='inverted-secondary'
                label={<><Icon name='sendMail'/><div>'lalalabel</div></>}/>
            <br/>
            <Dropdown label="disabled dropdown" disabled icon={<Icon name="lock" />} options={[{label: 'OUI', value: 'yes'}, {label: 'NON', value: 'no'}]}/>
            <Dropdown value={mandatoryDropdown} onChange={setMandatoryDropdown} label="mandatory dropdown" required icon={<Icon name="lock" />} options={[{label: 'JE SUIS UNE OPTION PLUTÔT LONGUE ALORS JE DOIS TENIR DANS LE DROPDOWN', value: 'yes'}, {label: 'NON', value: 'no'}]}/>
            <Dropdown value={errorDropdown} onChange={setErrorDropdown} label="error dropdown" errors="error in the dropdown" options={[{label: 'OUI', value: 'yes'}, {label: 'NON', value: 'no'}]}/>
            <Dropdown
                searchable
                value={errorDropdown}
                onChange={setErrorDropdown}
                label="searchable ordered dropdown"
                options={[
                    {label: 'OUI', value: 'yes', order: 2},
                    {label: 'NON', value: 'no', order: 1},
                    {label: 'PEUT ETRE', value: 'maybe', order: 0},
                    {label: 'JE SAIS PAS', value: 'idk', order: 4}
                ]}
            />
            <Dropdown label="Custom menu" hideChevron placeholder='special dropdown'>
                <Button label='I am a button'/>
                <TextArea error='Error message' label='Error TextArea'/>
                <TextArea error='Error message' label='Error TextArea'/>
            </Dropdown>
            <CountrySelector
                value={countrySelected}
                onChange={setCountrySelected}
                label="country"
                description="where your event is located"
                mostSelectedCountries={['FR']}
            />
            <br/>
            <DatePicker
                locale={localeDates}
                label='Date de la commande'
                required
                description='inscrite au dos du billet (dans la range)'
		    	value={dateOrder}
                minYear={new Date().getFullYear() - 1}
                maxYear={new Date().getFullYear() + 1}
                error={errorOrder}
                onClose={value => {
                    if (!dateOrder && !value.date) setErrorOrder('Il faut une valeur pour la date de commande!')
                    else setErrorOrder('');
                }}
		    	onChange={setDateOrder}
            />
            <DatePicker 
                label="Date de l'inscription"
                description='sans range'
                locale={localeDates}
		    	value={dateRegistration}
		    	onChange={setDateRegistration}
                disabled
            />
            <BirthdatePicker
                locale={localeDates}
                className='neo-date-picker'
                label="Date du concert (BirthdatePicker)"
                errors={dateError && dateOrder && dateError < dateOrder && 'Error: date du concert avant la commande!'}
		    	value={dateError}
		    	onChange={setDateError}
            />
            <PhoneInput
                required
                label="Phone number"
                description="in order for attendees to join you"
            />
            <LanguageSelector
                label="language"
                description="change language"
                required
                onChange={setLanguage}
                value={language}
                languages={['fr-FR', 'fr-CA', 'en-GB', 'en-CA', 'en-US', 'es-ES', 'ca-ES', 'it', 'it-IT', 'br', 'nl-NL', 'de-CH', 'de-DE', 'eu', 'ru-RU', 'pt-PT', 'el-GR', 'tr-TR']}
            />
            <LanguageSelector
                onChange={setLanguage}
                value={language}
                languages={['fr-FR', 'fr-CA', 'en-GB', 'en-CA', 'en-US', 'es-ES', 'ca-ES', 'it', 'it-IT', 'br', 'nl-NL', 'de-CH', 'de-DE', 'eu', 'ru-RU', 'pt-PT', 'el-GR', 'tr-TR']}
            />
            <UploadInput
                uniqueKey={0}
                fileTypes = {UploadInput.imageFileTypes}
                label = {"Upload file"}
                description = {"Upload file description"}
                required = {true}
                upload_config={uploadConfig}
                value={file}
                onChange={setFile}
            />
            <UploadInput
                uniqueKey={1}
                disabled={true}
                fileTypes = {UploadInput.imageFileTypes}
                label = {"Upload file disabled"}
                description = {"Upload file description"}
                upload_config={uploadConfig}
            />
            <UploadInput
                uniqueKey={2}
                fileTypes = {UploadInput.defaultFileTypes}
                label = {"Upload file error"}
                description = {"Upload file description"}
                required = {true}
                error = {'This field is required'}
                upload_config={uploadConfig}
            />
            <EventsFilter />
            <StepHeader lang={languageHeader} changeLanguage={(e, lang) => setLanguageHeader(lang.value)} config={{ step_header: { available_languages:['fr-FR', 'en-GB'], previous_button: {title: "Step test"}}}} />
            <AddressAutocomplete label={"Address"} description={"Location of the event"} required icon={<Icon name="externalLink" />} onChange={setAddressValue} value={addressValue} />
        </div>
    )
}